import { jsxs as r, jsx as i } from "react/jsx-runtime";
function e(n) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ r("g", { clipPath: "url(#clip0_3840_14182)", children: [
          /* @__PURE__ */ i("path", { d: "M3.125 10H16.875", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
          /* @__PURE__ */ i(
            "path",
            {
              d: "M11.25 4.375L16.875 10L11.25 15.625",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_3840_14182", children: /* @__PURE__ */ i("rect", { width: "20", height: "20", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
export {
  e as ThinArrowRightIcon
};
